"use client";
import React, { type JSX } from "react";
import { CopyRight } from "@/components/common/SocialLinks";
import { Icon } from "@/svg/Icon";
import square_shape_bottom from "@/assets/img/bg/square-shape-bottom.png";
import ceip_apm_logo from "@/assets/img/footer/ciep-apm.png"
import aog_logo from "@/assets/img/footer/association-of-ghostwriters.svg"
import square_shape_top from "@/assets/img/bg/square-shape-top.png";
import Image from "next/image";

interface DataType {
  title: string;
  title_2: JSX.Element;
  btn_text_1: string;
  btn_text_2: string;
  footer_data: {
    id: number;
    name: string;
    user_name: string;
    icon: React.JSX.Element;
    url: string;
    delay: string;
  }[];
}

const footer_content: DataType = {
  title: "Let's talk about the next big thing",
  title_2: (
    <>
      For better content,
      <br /> invoke the Muse today.
    </>
  ),
  btn_text_1: "Send an email",
  btn_text_2: "Invoke the muse",
  footer_data: [
    {
      id: 1,
      name: "Linked In",
      user_name: "@marie-ellis-content",
      icon: <Icon name="LinkedInWide"  />,
      url: "https://www.linkedin.com/in/marie-ellis-content/",
      delay: ".1s"
    },
    {
      id: 2,
      name: "Chartered Institute of Editors and Proofreaders",
      user_name: "Advanced Professional Member",
      icon: <Icon name="LogoCIEP_APM" />,
      url: "https://www.ciep.uk/directory/marie-ellis/",
      delay: ".3s"
    },
    {
      id: 3,
      name: "Association of Ghostwriters",
      user_name: "",
      icon: <Icon name="LogoAOG"/>,
      url: "https://associationofghostwriters.org/member-profile/marie_ellis/",
      delay: ".5s"
    }
  ],
};

const { btn_text_1, btn_text_2, title_2, footer_data } = footer_content;

const MuseFooter = () => {
  const bg_img = "/assets/img/footer/overly-bg-2.png";

  return (
    <footer id="contact">
      <div
        className={`tp-footer__customize overlay-bg p-relative fix z-index-1`}
        // style={{ backgroundImage: `url(${bg_img})` }}
      >
        <div className="ab-hero__shape-1">
          <Image src={square_shape_top} alt="image-here" />
        </div>
        {/* <div className="tp-footer__shape-2">
            <Image src={square_shape_bottom} alt="image-here" />
          </div> */}
        <div
          className={`tp-footer-area tp-footer-inner__customize pt-120`}
        >
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div className="tp-footer-content text-center">
                  <h3 className={`tp-footer-title tp_title_anim`}>{title_2}</h3>
                </div>
              </div>
            </div>

            <div className="tp-footer-btn-box">
              <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="tp-footer-btn text-center">
                    <a
                      className="tp-btn-grey-xl w-100"
                      target="_blank"
                      href="mailto:marie@musecontent.co.uk"
                    >
                      <div>
                        <span>{btn_text_1}</span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="tp-footer-link-area row gx-20 row-cols-xl-3 row-cols-lg-3 row-cols-md-3 row-cols-sm-1 row-cols-1">
              {footer_data.map((item, index) => (
                <div
                  key={index}
                  className="col-xl"
                >
                  <div
                    className="tp-footer-link-item wow tpfadeUp"
                    data-wow-duration=".9s"
                    data-wow-delay={item.delay}
                  >
                    <div>
                      <a target="_blank" href={item.url}>

                        <span style={{
                          display: "block",
                          width: "100%",
                          height: "100%"
                        }}>
                          {item.icon}
                        </span>

                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="tp-copyright-area pb-20">
          <div className="container">
            <div className="row">
              <div className="col-xl-6 col-md-6">
                <div className="tp-copyright-content-left text-center text-md-start">
                  <p>
                    <CopyRight />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default MuseFooter;
